import React from "react";
import {
	Box,
	Grid,
	Typography,
	IconButton,
	Button,
	FormControl,
	InputLabel,
	Select,
	OutlinedInput,
	MenuItem,
	Checkbox,
	LinearProgress,
} from "@mui/material";
import { alpha } from "@mui/system";
import { Add, Delete, Devices } from "@mui/icons-material";

export default function CpeSection({
	theme,
	selectors,
	allHostsCliente,
	handleHostChange,
	handleInterfaceChange,
	addSelector,
	removeSelector,
	loadingHost,
	loadingHostClient,
	loadingInterface,
}) {
	return (
		<Box
			sx={{
				p: 2,
				bgcolor: theme.palette.background.paper,
				borderRadius: "12px",
				width: "100%",
				mb: 1,
			}}
		>
			{/* Cabeçalho */}
			<Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
				<Box
					sx={{
						backgroundColor: alpha(theme.palette.primary.main, 0.2),
						borderRadius: "10px",
						width: "35px",
						height: "35px",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
					}}
				>
					<Devices
						fontSize="small"
						sx={{
							color:
								theme.palette.mode === "dark"
									? theme.palette.primary.light
									: theme.palette.primary.dark,
						}}
					/>
				</Box>
				<Typography variant="h6" sx={{ fontWeight: "bold", fontSize: "16px" }}>
					Hosts e Interfaces
				</Typography>
			</Box>

			{selectors.map((selector) => (
				<Box
					key={selector.id}
					sx={{
						border: "1px solid",
						borderColor: theme.palette.divider,
						pb: 2,
						pl: 2,
						pr: 2,
						borderRadius: "12px",
						mt: 2,
					}}
				>
					<Grid container spacing={1} sx={{ mt: 1, alignItems: "center" }}>
						{/* Seletor de Host */}
						<Grid item xs={12} sm={5.5}>
							<Box sx={{ position: "relative", display: "flex", flexDirection: "column", gap: 1 }}>
								{(loadingHost || loadingHostClient) && (
									<LinearProgress
										sx={{ position: "absolute", top: -5, left: 0, right: 0 }}
									/>
								)}
								<FormControl size="small" fullWidth>
									<InputLabel>Hosts</InputLabel>
									<Select
										value={selector.hostId}
										onChange={(e) => handleHostChange(selector.id, e.target.value)}
										label="Hosts"
										disabled={loadingHost || loadingHostClient}
										sx={{ borderRadius: "12px" }}
									>
										{allHostsCliente
											?.filter((host) => {
												const selectedHostIds = selectors
													.filter((s) => s.id !== selector.id)
													.map((s) => s.hostId);
												return !selectedHostIds.includes(host?.hostid);
											})
											?.map((host) => (
												<MenuItem key={host.hostid} value={host?.hostid}>
													{host?.host ? host?.servicoId + ' - ' + host?.host : host?.host}
												</MenuItem>
											))}
									</Select>
								</FormControl>
							</Box>
						</Grid>

						{/* Seletor de Interfaces */}
						<Grid item xs={12} sm={5.5}>
							<Box sx={{ position: "relative", display: "flex", flexDirection: "column", gap: 1 }}>
								{!selector?.interfaces.length && loadingInterface && (
									<LinearProgress
										sx={{ position: "absolute", top: -5, left: 0, right: 0 }}
									/>
								)}
								<FormControl size="small" fullWidth>
									<InputLabel>Interfaces</InputLabel>
									<Select
										multiple
										disabled={!selector.hostId || loadingInterface}
										value={selector.interfaces}
										onChange={(e) => handleInterfaceChange(selector.id, e.target.value)}
										input={<OutlinedInput label="Interfaces" sx={{ borderRadius: "12px" }} />}
										renderValue={(selected) => (
											<Typography variant="body2">
												{selected.length === selector.availableInterfaces?.length &&
												selector.availableInterfaces?.length > 0
													? "Todas as interfaces"
													: `${selected.length} selecionada(s)`}
											</Typography>
										)}
									>
										<MenuItem
											key="select-all"
											value="Selecionar Todas"
											sx={{
												fontWeight: "bold",
												backgroundColor:
													selector.interfaces.length ===
													selector.availableInterfaces?.length
														? theme.palette.action.selected
														: "inherit",
											}}
										>
											<Checkbox
												checked={
													selector.interfaces.length ===
														selector.availableInterfaces?.length &&
													selector.availableInterfaces?.length > 0
												}
												indeterminate={
													selector.interfaces.length > 0 &&
													selector.interfaces.length <
														selector.availableInterfaces?.length
												}
											/>
											Selecionar Todas
										</MenuItem>
										{selector.availableInterfaces?.map((interfaceObj) => {
											const ifName = interfaceObj.name || interfaceObj;
											const ifDesc = interfaceObj.description;
											const label = ifDesc ? `${ifName} - ${ifDesc}` : ifName;
											return (
												<MenuItem key={ifName} value={ifName}>
													<Checkbox
														checked={selector.interfaces.includes(ifName)}
													/>
													{label}
												</MenuItem>
											);
										})}
									</Select>
								</FormControl>
							</Box>
						</Grid>

						{/* Botão Remover */}
						<Grid
							item
							xs={12}
							sm={1}
							sx={{ display: "flex", justifyContent: "center" }}
						>
							<IconButton
								size="small"
								onClick={() => removeSelector(selector.id)}
								disabled={selectors.length === 1}
							>
								<Delete
									color={selectors.length === 1 ? "disabled" : "error"}
									fontSize="small"
								/>
							</IconButton>
						</Grid>
					</Grid>
				</Box>
			))}

			<Grid item xs={12} sx={{ mt: 2 }}>
				<Button
					size="small"
					variant="outlined"
					startIcon={<Add />}
					onClick={addSelector}
					sx={{ width: "100%", borderRadius: "8px" }}
				>
					Adicionar Host/Interface
				</Button>
			</Grid>
		</Box>
	);
}
